import { apiUrl } from '@/api/axios';
import { handleResponseError } from '@/core/utils/handleResponseError';

/**
 * Минимальный структурный контракт generic-слайса (`createGenericSlice`),
 * который нужен этой утилите. Методный синтаксис даёт бивариантную проверку
 * параметров — поэтому типизированные `PayloadAction`-креаторы присваиваются.
 */
interface DeleteDataSlice {
	actions: {
		deleteDataSuccess(item: string): unknown;
		fetchDataError(payload: { errorMessage: string; isNetworkError?: boolean }): unknown;
	};
}

export const deleteData = (slice: DeleteDataSlice, url: string) => (item: string) => async (dispatch) => {
	// dispatch(slice.actions.fetchDataStart());

	try {
		const requestUrl = `${url}${item}`;
		const response = await apiUrl.delete(requestUrl);

		if (response.status === 200) {
			dispatch(slice.actions.deleteDataSuccess(item));
			return true;
		}
	} catch (error) {
		handleResponseError(error, (errorMessage, isNetworkError) => {
			dispatch(slice.actions.fetchDataError({ errorMessage, isNetworkError }));
		});
		return false;
	}
};
